import { useEffect } from "react";

/**
 * Imperatively manages a single `<meta name="robots">` tag on the document.
 * The Vite SPA has no head-manager dependency yet; this hook adds the tag
 * when `content` is non-null and removes it on unmount or when `content`
 * becomes null. Re-rendering with the same content is a no-op.
 *
 * Issue #296 — past gatherings render with `noindex` so search engines drop
 * the URL after the start date passes.
 */
export function useRobotsMeta(content: string | null): void {
  useEffect(() => {
    if (content === null) {
      const existing = document.querySelector(
        'meta[name="robots"]',
      ) as HTMLMetaElement | null;
      if (existing) existing.remove();
      return;
    }

    let meta = document.querySelector(
      'meta[name="robots"]',
    ) as HTMLMetaElement | null;
    let createdHere = false;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.appendChild(meta);
      createdHere = true;
    }
    meta.content = content;

    return () => {
      if (createdHere) meta?.remove();
    };
  }, [content]);
}
